import { User } from "./access";

export enum AccessManagementAction {
    SET_USERS = "[AccessManagementAction] SET_USERS",
}

interface SetUserList {
    type: AccessManagementAction.SET_USERS;
    users: User[];
}

export type AccessActionTypes = SetUserList;
